
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { IAcademy } from '@/interfaces/academy';
import { academyStore, mainStore } from '@/store';
import _ from 'lodash';

@Component
export default class Create extends Vue {
  @Prop({ type: Number, default: 0 }) readonly propAcademyId;
  @Prop({ type: Number, default: 0 }) readonly propState;

  @Watch('categoria_id')
  onGetNameCategory() {
    this.categoria_name = this.categoryOptions.find((i) => i.id === this.categoria_id).name;
  }

  public isLoading = false;
  public srcvimeo = '';
  public srcimg = '';
  public titlevideo = '';
  public description = '';
  public categoria_name = '';
  public categoria_id = 0;
  public ordemexibicao = 0;
  public academy = [];
  public editVideo = false;
  public controlBtn = false;

  public selectedFuncoes: number[] | null = null;
  public funcoes = [
    { name: 'Diretor', value: 1 },
    { name: 'Supervisor', value: 2 },
    { name: 'Coordenador/Gerente', value: 3 },
    { name: 'Consultor', value: 4 },
    { name: 'Professor', value: 5 },
    { name: 'Operacional', value: 6 },
    { name: 'CDA', value: 7 },
    { name: 'Franqueado', value: 8 },
  ];

  get categoryOptions() {
    const order = [
      { id: 1, name: 'Situações de sala de aula' },
      { id: 2, name: 'Book Seeds' },
      { id: 3, name: 'Keep talking Seeds' },
      { id: 4, name: 'Advanced' },
      { id: 5, name: 'On the Road' },
      { id: 6, name: 'Kinder' },
      { id: 7, name: 'Kids' },
      { id: 8, name: 'Tweens' },
      { id: 9, name: 'Teens' },
      { id: 10, name: 'Alemão' },
      { id: 11, name: 'Espanhol' },
      { id: 12, name: 'Francês' },
      { id: 13, name: 'Procedimentos Pedagógicos' },
      { id: 14, name: 'Coordenação Pedagógica' },
      { id: 15, name: 'Administrativo' },
      { id: 16, name: 'Administrativo Pedagógico' },
      { id: 17, name: 'Administrativo Financeiro' },
      { id: 18, name: 'Coordenação Pais e alunos' },
      { id: 19, name: 'Direção da escola' },
      { id: 20, name: 'Marketing digital' },
      { id: 21, name: 'Comercial interno' },
      { id: 22, name: 'Comercial externo' },
      { id: 23, name: 'Gerência comercial' },
      { id: 24, name: 'CDA' },
      { id: 25, name: 'Implantação' },
      { id: 26, name: 'Treinamento inicial inglês' },
      { id: 27, name: 'Treinamento inicial alemão' },
      { id: 28, name: 'Treinamento inicial francês' },
      { id: 29, name: 'Treinamento inicial espanhol' },
      { id: 30, name: 'Treinamento inicial coordenação pedagógica' },
      { id: 31, name: 'Treinamento inicial de pais e alunos' },
      { id: 32, name: 'Treinamento inicial administrativo' },
      { id: 33, name: 'Marketing' },
      { id: 34, name: 'Demonstrativa' },
      { id: 35, name: 'Objeções e contorno de objeções' },
    ];
    return _.orderBy(order, 'name');
  }

  get currentUser() {
    return mainStore.userProfile;
  }

  public async handleSaveVideo() {
    let video: IAcademy = {
      srcvideo: this.srcvimeo,
      srcimg: this.srcimg,
      title: this.titlevideo,
      description: this.description,
      category_id: this.categoria_id,
      category: this.categoria_name,
      roles: this.selectedFuncoes,
      ordem: this.ordemexibicao,
    };

    if (!this.editVideo) {
      this.academy = await academyStore.createAcademy(video);
      this.controlBtn = true;
    } else {
      video['id'] = this.propAcademyId;
      this.academy = await academyStore.updateAcademy(video);
    }
    this.$emit('getPropState', Math.floor(Math.random() * 200));
  }

  public async mounted() {
    this.isLoading = true;

    if (this.propAcademyId > 0) {
      this.academy = await academyStore.getAcademyById(this.propAcademyId);

      if (this.academy.length > 0) {
        this.srcvimeo = this.academy[0]['srcvideo'];
        this.srcimg = this.academy[0]['srcimg'];
        this.titlevideo = this.academy[0]['title'];
        this.description = this.academy[0]['description'];
        this.categoria_name = this.academy[0]['category'];
        this.categoria_id = this.academy[0]['category_id'];
        this.selectedFuncoes = this.academy[0]['roles'];
        this.ordemexibicao = this.academy[0]['ordem'];
        this.editVideo = true;
      }
    }

    this.isLoading = false;
  }
}
